import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceDietitianDashboardPatientData(params) {
  return await postRequest("dashboard/patients-data", params);
}


export async function serviceDietitianDashboardTimeSpentData(params) {
  return await postRequest("dashboard/time-spent-data", params);
}


export async function serviceDietitianDashboardPatientTrend(params) {
  return await postRequest("dashboard/patients-trend", params);
}


export async function serviceDietitianDashboardConsultationRecord(params) {
  return await postRequest("dashboard/consultation-record", params);
}

export async function serviceDietitianDashboardUpcomingSessions(params) {
  return await postRequest("dashboard/upcoming-sessions", params);
}

export async function serviceDietitianDashboardConsultationHistory(params) {
  return await postRequest("dashboard/consultation-history", params);
}

export async function serviceDietitianDashboardPatientDetail(params) {
  return await postRequest("dashboard/patient-details", params);
}
